import React from 'react';
import { useShowTime } from '@/hooks';
import cx from './index.module.scss';

interface Props {}

const FormatTime: React.FC<Props> = props => {
  const time = useShowTime('星期dd&HH:mm');

  return (
    <div className={cx('time')}>
      <div className={cx('week')}>{time?.split('&')[0]}</div>
      <div className={cx('line')}>|</div>
      <div className={cx('minute')}>{time?.split('&')[1]}</div>
    </div>
  );
};

export default FormatTime;
